import VerifyAccount from "./VerifyAccount";
export default VerifyAccount;
